function parseCapiError(error) {
  const result = {
    codes: new Set(),
    codeLookup: {},
    errors: [],
    messages: new Set()
  };

  if (error.response && error.response.data && Array.isArray(error.response.data.errors)) {
    error.response.data.errors.forEach((e) => {
      const { code, message } = e;

      result.errors.push(e);
      result.codeLookup[code] = e;
      result.codes.add(code);
      result.messages.add(message);
    });
  }

  result.codes = Array.from(result.codes);
  result.messages = Array.from(result.messages);

  return result;
}



export default parseCapiError;
